module.exports = __webpack_public_path__ + "img/Platinum.94912702.png";